import { combineReducers } from 'redux';

import forumContribute from './forumContribute/reducer';

export default combineReducers({
  forumContribute
});



/** WEBPACK FOOTER **
 ** ./src/members/state/forum/textEditing/reducer.js
 **/